import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiRefreshCw,
  FiDownload,
  FiCheckCircle,
  FiAlertCircle,
  FiCalendar,
  FiFileText,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function Reconciliation() {
  const [searchTerm, setSearchTerm] = useState("");
  const [dateFilter, setDateFilter] = useState("today");
  const [reconciliationDate, setReconciliationDate] = useState(new Date().toISOString().split("T")[0]);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [mismatches] = useState([
    {
      id: 1,
      orderId: "ORD-001",
      userId: "USR-001",
      userName: "Rajesh Kumar",
      ourAmount: 50000,
      partnerAmount: 50000,
      ourStatus: "Completed",
      partnerStatus: "Pending",
      mismatchType: "Status Mismatch",
      reconciliationDate: "2024-01-20",
    },
    {
      id: 2,
      orderId: "ORD-002",
      userId: "USR-002",
      userName: "Priya Sharma",
      ourAmount: 25000,
      partnerAmount: 30000,
      ourStatus: "Completed",
      partnerStatus: "Completed",
      mismatchType: "Amount Mismatch",
      reconciliationDate: "2024-01-20",
    },
    {
      id: 3,
      orderId: "ORD-003",
      userId: "USR-003",
      userName: "Amit Patel",
      ourAmount: 75000,
      partnerAmount: null,
      ourStatus: "Completed",
      partnerStatus: null,
      mismatchType: "Missing Allotment",
      reconciliationDate: "2024-01-19",
    },
  ]);

  const handleRunReconciliation = () => {
    Swal.fire({
      title: "Run Daily Reconciliation?",
      text: "This will reconcile all orders for the selected date.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Run Reconciliation",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Reconciliation Running...",
          text: "Please wait while we reconcile orders.",
          icon: "info",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        setTimeout(() => {
          Swal.fire("Success!", "Daily reconciliation completed successfully.", "success");
        }, 2000);
      }
    });
  };

  const handleResolveMismatch = (mismatchId) => {
    Swal.fire({
      title: "Resolve Mismatch?",
      text: "This will mark the mismatch as resolved.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Resolve",
      confirmButtonColor: "#10b981",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Resolved!", "Mismatch has been resolved.", "success");
      }
    });
  };

  const handleResync = (orderId) => {
    Swal.fire({
      title: "Resync Order?",
      text: "This will trigger a resync with the partner.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Resync",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Resync Started!", "Order resync process initiated.", "success");
      }
    });
  };

  const formatINR = (amount) => {
    if (!amount) return "-";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredMismatches = mismatches.filter((mismatch) => {
    const matchesSearch =
      mismatch.orderId.includes(searchTerm) ||
      mismatch.userName.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesSearch;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMismatches.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredMismatches.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="content-page-header content-page-headersplit">
                <h5>Reconciliation</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/mutual-funds/reconciliation">Mutual Funds</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Reconciliation
                  </li>
                </ol>
              </nav>
              
         
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-4">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by order ID or user name..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="position-relative">
                    <FiCalendar
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="date"
                      className="form-control"
                      value={reconciliationDate}
                      onChange={(e) => {
                        setReconciliationDate(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                <button
                  className="btn btn-primary me-2"
                  onClick={handleRunReconciliation}
                >
                  Run Reconciliation
                </button>
                <button className="btn btn-secondary">
                  Export Report
                </button>
              </div>
              </div>
            </div>

            {/* Reconciliation Summary Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row g-3">
            <div className="col-12 col-md-4">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                  borderLeft: "4px solid #ef4444",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontWeight: "500" }}>Mismatches Found</p>
                      <h3 className="mb-0" style={{ color: "#ef4444" }}>
                        {mismatches.length}
                      </h3>
                    </div>
                    <FiAlertCircle style={{ fontSize: "32px", color: "#ef4444" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
                  borderLeft: "4px solid #10b981",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontWeight: "500" }}>Resolved</p>
                      <h3 className="mb-0" style={{ color: "#10b981" }}>
                        0
                      </h3>
                    </div>
                    <FiCheckCircle style={{ fontSize: "32px", color: "#10b981" }} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-4">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "none" }}>
                <div className="card-body p-4" style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  borderLeft: "4px solid #006e82",
                }}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <p className="mb-1" style={{ color: "#64748b", fontWeight: "500" }}>Last Reconciliation</p>
                      <h6 className="mb-0" style={{ color: "#006e82" }}>
                        {reconciliationDate}
                      </h6>
                    </div>
                    <FiCalendar style={{ fontSize: "32px", color: "#006e82" }} />
                  </div>
                </div>
              </div>
              </div>
            </div>

            {/* Mismatches Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Order ID</th>
                          <th>User</th>
                          <th>Our Amount</th>
                          <th>Partner Amount</th>
                          <th>Our Status</th>
                          <th>Partner Status</th>
                          <th>Mismatch Type</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="8">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((mismatch) => (
                            <tr key={mismatch.id}>
                              <td style={{ fontWeight: "500" }}>{mismatch.orderId}</td>
                              <td style={{ fontWeight: "500" }}>{mismatch.userName}</td>
                              <td style={{ fontWeight: "600" }}>{formatINR(mismatch.ourAmount)}</td>
                              <td style={{ color: mismatch.partnerAmount !== mismatch.ourAmount ? "#ef4444" : "#1e293b", fontWeight: "600" }}>
                                {formatINR(mismatch.partnerAmount)}
                              </td>
                              <td>
                                <span className="badge-active">
                                  {mismatch.ourStatus}
                                </span>
                              </td>
                              <td>
                                {mismatch.partnerStatus ? (
                                  <span className={mismatch.partnerStatus === "Completed" ? "badge-active" : "badge-pending"}>
                                    {mismatch.partnerStatus}
                                  </span>
                                ) : (
                                  <span className="badge-pending">
                                    Missing
                                  </span>
                                )}
                              </td>
                              <td>
                                <span className="badge-pending">
                                  {mismatch.mismatchType}
                                </span>
                              </td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <button
                                    className="btn btn-sm me-2"
                                    style={{
                                      background: "#d1fae5",
                                      color: "#10b981",
                                      border: "none",
                                      borderRadius: "6px",
                                      padding: "4px 12px",
                                    }}
                                    onClick={() => handleResolveMismatch(mismatch.id)}
                                    title="Resolve Mismatch"
                                  >
                                    {/* <FiCheckCircle style={{ fontSize: "14px", marginRight: "4px" }} /> */}
                                    Resolve
                                  </button>
                                  <div
                                    className="delete-table"
                                    onClick={() => handleResync(mismatch.orderId)}
                                    title="Resync Order"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-redo"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
      </div>
    </>
  );
}
